(() => {
  const qs = (s, r = document) => r.querySelector(s);
  const qsa = (s, r = document) => [...r.querySelectorAll(s)];
  const money = (cents, currency = window.Shopify?.currency?.active || 'USD') =>
    new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(cents / 100);

  const cartCountEls = () => qsa('[data-cart-count]');
  function setCount(n) {
    cartCountEls().forEach((el) => {
      el.textContent = n;
      if (n > 0) el.removeAttribute('hidden');
      else el.setAttribute('hidden', '');
    });
  }

  async function cart() {
    const res = await fetch('/cart.js');
    return res.json();
  }

  async function addToCart(id, qty = 1, properties) {
    const variantId = Number(id);
    if (!variantId) throw new Error('Missing product variant.');
    const payload = { id: variantId, quantity: Math.max(1, Number(qty) || 1) };
    if (properties && Object.keys(properties).length) payload.properties = properties;
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    });
    if (!res.ok) {
      let msg = 'Could not add to cart.';
      try {
        const err = await res.json();
        msg = err.description || err.message || msg;
      } catch (_) { /* keep */ }
      throw new Error(msg);
    }
    const data = await cart();
    setCount(data.item_count);
    document.querySelectorAll('.cart-count').forEach((el) => {
      el.classList.remove('pop');
      void el.offsetWidth;
      el.classList.add('pop');
    });
    renderDrawer(data);
    requestAnimationFrame(() => openDrawer());
    setTimeout(() => openDrawer(), 40);
    return data;
  }

  async function changeCart(key, quantity) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity }),
    });
    const data = await res.json();
    setCount(data.item_count);
    renderDrawer(data);
    return data;
  }

  let drawerScrollY = 0;
  function openDrawer() {
    const drawer = qs('[data-drawer]');
    const overlay = qs('[data-drawer-overlay]');
    if (overlay) overlay.classList.add('open');
    if (drawer) drawer.classList.add('open');
    if (!document.body.classList.contains('cart-drawer-open')) {
      drawerScrollY = window.scrollY || document.documentElement.scrollTop || 0;
    }
    document.documentElement.classList.add('cart-drawer-open');
    document.body.classList.add('cart-drawer-open');
    document.body.style.top = `-${drawerScrollY}px`;
  }
  function closeDrawer() {
    qs('[data-drawer]')?.classList.remove('open');
    qs('[data-drawer-overlay]')?.classList.remove('open');
    document.documentElement.classList.remove('cart-drawer-open');
    document.body.classList.remove('cart-drawer-open');
    document.body.style.top = '';
    document.body.style.overflow = '';
    window.scrollTo(0, drawerScrollY);
  }

  function sellerUrl(name) {
    return `${window.TCGSellers?.root || '/'}?view=seller#/seller/${encodeURIComponent(name)}`;
  }

  function itemImage(item) {
    return item.featured_image?.url || item.image || '';
  }

  function renderDrawer(data) {
    const body = qs('[data-drawer-body]');
    const foot = qs('[data-drawer-foot]');
    if (!body || !foot) return;
    const shopName = window.TCGSellers?.shopName || 'Marketplace';
    if (!data.items.length) {
      body.innerHTML = '<p class="empty">Your cart is empty.</p>';
      foot.innerHTML = '';
      return;
    }
    body.innerHTML = data.items.map((item) => {
      const seller = item.properties?.Seller || shopName;
      const src = itemImage(item);
      return `
        <div class="drawer-item">
          <div class="drawer-thumb">${src ? `<img src="${src}" alt="">` : ''}</div>
          <div class="drawer-info">
            <strong>${item.product_title}</strong>
            <div class="cart-seller">Sold by <a href="${sellerUrl(seller)}">${seller}</a></div>
            <div class="drawer-price">${money(item.final_price)}</div>
            <input class="drawer-qty" type="number" min="1" value="${item.quantity}" data-cart-key="${item.key}">
          </div>
          <button type="button" class="drawer-remove" data-remove="${item.key}"><span>Remove</span></button>
        </div>`;
    }).join('');
    const threshold = Number(window.TCGSellers?.freeShip || 50);
    const remain = threshold * 100 - data.total_price;
    const pct = threshold > 0 ? Math.min(100, (data.total_price / (threshold * 100)) * 100) : 0;
    const shipText = remain > 0
      ? `${money(remain)} away from free shipping`
      : 'You unlocked free shipping.';
    foot.innerHTML = `
      <p class="ship-away">${shipText}</p>
      <div class="shipping-bar"><span style="width:${remain > 0 ? pct : 100}%"></span></div>
      <div class="drawer-sum"><span>Subtotal</span><strong>${money(data.total_price)}</strong></div>
      <a class="btn btn-outline drawer-view" href="/cart">View cart</a>
      <a class="btn btn-blue drawer-checkout" href="/checkout">Check out</a>`;
  }

  function lockProductForms() {
    qsa('.product-form, form[data-product-form]').forEach((form) => {
      form.setAttribute('novalidate', 'novalidate');
      const action = form.getAttribute('action') || '';
      if (action.includes('/cart/add') && !action.includes('.js')) {
        form.dataset.shopifyAction = action;
        form.setAttribute('action', '#');
      }
    });
  }
  lockProductForms();

  document.addEventListener('click', (e) => {
    if (!e.target.closest('[data-open-cart]')) return;
    e.preventDefault();
    e.stopPropagation();
    cart().then((d) => { renderDrawer(d); openDrawer(); });
  }, true);

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-open-cart]')) {
      e.preventDefault();
      return;
    }
    if (e.target.closest('[data-close-cart], [data-drawer-overlay]')) closeDrawer();
    const rm = e.target.closest('[data-drawer] [data-remove]');
    if (rm) changeCart(rm.dataset.remove, 0);
    if (e.target.closest('[data-ship]')) {
      e.preventDefault();
      const loc = window.TCGSellers?.shipLocation || 'Morocco';
      document.querySelector('.ship-modal')?.remove();
      const modal = document.createElement('div');
      modal.className = 'modal ship-modal';
      modal.innerHTML = `<div class="modal-card">
        <h3>Shipping to ${loc}</h3>
        <p>Your current location is set to <strong>${loc}</strong>. Only sellers that ship to this location will be displayed.</p>
        <p><strong>Shop U.S. Products</strong></p>
        <p class="muted">You can shop the marketplace and get orders sent through international shipping partners in one tracked package.</p>
        <div class="modal-actions">
          <button class="btn btn-outline" type="button" data-close>Close</button>
        </div>
      </div>`;
      modal.addEventListener('click', (ev) => {
        if (ev.target === modal || ev.target.closest('[data-close]')) modal.remove();
      });
      document.body.append(modal);
    }
    if (e.target.closest('[data-open-menu]')) {
      qs('[data-mobile-nav]')?.classList.add('open');
      const bg = qs('.mobile-nav-bg');
      if (bg) bg.hidden = false;
      document.body.classList.add('nav-open');
    }
    if (e.target.closest('[data-close-menu]') || e.target.closest('[data-mobile-nav] a')) {
      qs('[data-mobile-nav]')?.classList.remove('open');
      const bg = qs('.mobile-nav-bg');
      if (bg) bg.hidden = true;
      document.body.classList.remove('nav-open');
    }
    const thumb = e.target.closest('[data-thumb]');
    if (thumb) {
      const main = qs('[data-main-image]');
      if (main) main.src = thumb.dataset.thumb;
    }
    if (e.target.closest('[data-toggle-filters]')) {
      qs('[data-filter-panel]')?.classList.toggle('open');
    }
  });

  document.addEventListener('change', (e) => {
    const qty = e.target.closest('[data-cart-key]');
    if (qty) changeCart(qty.dataset.cartKey, Number(qty.value));
    if (e.target.matches('[data-sort]')) {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', e.target.value);
      window.location.href = url.toString();
    }
  });

  async function runAddButton(btn) {
    if (!btn || btn.disabled || btn.dataset.adding === '1') return;
    const form = btn.closest('form') || qs('.product-form');
    const id = form?.querySelector('[name="id"]')?.value || btn.dataset.variantId;
    const qty = Number(form?.querySelector('[name="quantity"]')?.value || 1);
    const sellerName = qs('[data-buy-seller] a')?.textContent?.trim();
    const cond = qs('[data-buy-cond]')?.textContent?.trim();
    const properties = {};
    if (sellerName) properties.Seller = sellerName;
    if (cond) properties.Condition = cond;
    const label = btn.textContent;
    btn.dataset.adding = '1';
    btn.disabled = true;
    btn.classList.add('is-loading');
    btn.textContent = 'Adding...';
    try {
      await addToCart(id, qty, properties);
    } catch (err) {
      alert(err.message || 'Could not add to cart.');
    } finally {
      btn.disabled = false;
      btn.classList.remove('is-loading');
      btn.textContent = label;
      delete btn.dataset.adding;
    }
  }

  document.addEventListener('submit', (e) => {
    const form = e.target.closest('.product-form, [data-product-form]');
    if (!form) return;
    e.preventDefault();
    e.stopPropagation();
    const btn = form.querySelector('[data-add-btn]');
    if (btn) runAddButton(btn);
  }, true);

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-add-btn]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    runAddButton(btn);
  }, true);

  const variantJson = qs('[data-variant-json]');
  const idInput = qs('[data-variant-id]');
  const priceEl = qs('[data-variant-price]');
  const skuEl = qs('[data-variant-sku]');
  const availEl = qs('[data-variant-avail]');
  if (variantJson) {
    const variants = JSON.parse(variantJson.textContent);
    function selectedOptions() {
      return qsa('[data-option]', qs('[data-product-form]')).map((sel) => sel.value);
    }
    function sync() {
      const opts = selectedOptions();
      const match = variants.find((v) => v.options.every((o, i) => o === opts[i]));
      if (!match) return;
      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.innerHTML = match.compare_at_price > match.price
        ? `${money(match.price)} <span class="price-compare">${money(match.compare_at_price)}</span>`
        : money(match.price);
      if (skuEl) skuEl.textContent = match.sku || '';
      if (availEl) availEl.textContent = match.available ? 'In stock' : 'Sold out';
      const btn = qs('[data-add-btn]');
      if (btn) btn.disabled = !match.available;
      const featured = match.featured_image;
      const main = qs('[data-main-image]');
      if (featured && main) main.src = featured.src;
    }
    qsa('[data-option]').forEach((el) => el.addEventListener('change', sync));
  }

  qs('[data-header-search]')?.addEventListener('submit', (e) => {
    const form = e.currentTarget;
    const game = form.querySelector('[data-search-game]')?.value?.trim();
    const input = form.querySelector('[name="q"]');
    if (game && input && !input.value.toLowerCase().includes(game.toLowerCase())) {
      input.value = input.value.trim() ? `${game} ${input.value.trim()}` : game;
    }
  });

  const searchInput = qs('[data-predictive-input]');
  const box = qs('[data-predictive]');
  let t;
  searchInput?.addEventListener('input', () => {
    clearTimeout(t);
    const q = searchInput.value.trim();
    if (q.length < 2) { box?.classList.remove('open'); return; }
    t = setTimeout(async () => {
      const res = await fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product,collection&resources[limit]=6`);
      const json = await res.json();
      const products = json.resources?.results?.products || [];
      const collections = json.resources?.results?.collections || [];
      if (!box) return;
      box.innerHTML = [
        ...collections.map((c) => `<a href="${c.url}"><div><strong>${c.title}</strong><div class="muted">Collection</div></div></a>`),
        ...products.map((p) => `<a href="${p.url}"><img src="${p.image || ''}" alt=""><div><strong>${p.title}</strong><div class="muted">${p.price}</div></div></a>`),
      ].join('') || '<div class="empty">No suggestions</div>';
      box.classList.add('open');
    }, 180);
  });
  document.addEventListener('click', (e) => {
    if (!e.target.closest('.search')) box?.classList.remove('open');
  });

  const recentKey = 'tcg-recently-viewed';
  const recentEl = qs('[data-recent-product]');
  if (recentEl) {
    try {
      const item = JSON.parse(recentEl.textContent);
      const list = JSON.parse(localStorage.getItem(recentKey) || '[]')
        .filter((x) => x.id !== item.id);
      localStorage.setItem(recentKey, JSON.stringify([item, ...list].slice(0, 12)));
    } catch (_) { /* ignore */ }
  }

  const row = qs('[data-recently-row]');
  if (row) {
    const saved = (() => {
      try { return JSON.parse(localStorage.getItem(recentKey) || '[]'); } catch (_) { return []; }
    })();
    if (saved.length) {
      row.innerHTML = saved.map((p) => `
        <div class="rv-card-wrap">
          <a class="rv-card" href="${p.url}">
            <div class="rv-img">${p.image ? `<img src="${p.image}" alt="">` : ''}</div>
            <div class="rv-name">${p.title || ''}</div>
            <div class="rv-set">${p.type || ''}</div>
          </a>
        </div>`).join('');
    }
    const dots = qs('[data-recently-dots]');
    const prev = qs('[data-recently-prev]');
    const next = qs('[data-recently-next]');
    let page = 0;
    function perPage() {
      const w = window.innerWidth;
      if (w <= 700) return 1;
      if (w <= 1100) return 3;
      return 5;
    }
    function pages() {
      return Math.max(1, Math.ceil(row.children.length / perPage()));
    }
    function paint() {
      const n = perPage();
      const max = pages() - 1;
      page = Math.min(page, max);
      const card = row.children[0];
      const step = card ? card.getBoundingClientRect().width + 16 : 0;
      row.style.transform = `translateX(-${page * n * step}px)`;
      if (dots) {
        dots.innerHTML = Array.from({ length: pages() }, (_, i) =>
          `<button type="button" class="${i === page ? 'on' : ''}" data-rv-page="${i}"></button>`).join('');
      }
      if (prev) prev.disabled = page <= 0;
      if (next) next.disabled = page >= max;
    }
    prev?.addEventListener('click', () => { page -= 1; paint(); });
    next?.addEventListener('click', () => { page += 1; paint(); });
    dots?.addEventListener('click', (e) => {
      const b = e.target.closest('[data-rv-page]');
      if (!b) return;
      page = Number(b.dataset.rvPage);
      paint();
    });
    window.addEventListener('resize', paint);
    paint();
  }

  window.themeCart = { addToCart, openDrawer, closeDrawer, renderDrawer, cart, setCount };
  cart().then((d) => setCount(d.item_count)).catch(() => {});
})();
